import React from 'react';
import { useLocale } from '../../hooks/useLocale';
import { useStoreActions, useStoreState } from '../../store';
import { Browser } from '../../utils/browser';
import { MenuHeader } from './MenuHeader';
import { OptionRow, SubmenuScreenContent } from './styles';

export const AudioScreen = () => {
  const locale = useLocale();
  const actions = useStoreActions((actions) => actions);
  const ignoreVideoEvents = useStoreState((state) => state.player.ignoreVideoEvents);
  const audioTracks = useStoreState((state) => state.player.audioTracks);
  const audioTrack = useStoreState((state) => state.player.audioTrack);

  function handleAudioTrackChange(track: AudioTrack) {
    if (ignoreVideoEvents) return;
    actions.player.setAudioTrack(track);
    actions.settings.setAudioTrack(track);
  }

  return (
    <SubmenuScreenContent>
      <MenuHeader
        title={locale.translations.LanguageOptions.Audio}
        onBack={() => actions.languageMenu.navigateBack()}
      />
      {audioTracks
        .sort((trackA, trackB) => {
          if (Browser.isSafari || Browser.isIOS) return trackA.id > trackB.id ? 1 : -1;
          return 0;
        })
        .map((track) => (
          <OptionRow
            key={track.id}
            active={audioTrack === track}
            isDisabled={ignoreVideoEvents}
            onClick={() => handleAudioTrackChange(track)}
          >
            {track.label}
          </OptionRow>
        ))}
    </SubmenuScreenContent>
  );
};
